import * as React from "react";
import {Grid2 as Grid} from "@mui/material";
import {IconButtonEx} from "@/lib/components/buttons/IconButtonEx";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {ButtonEx} from "@/lib/components/buttons/ButtonEx";
import {useTranslation} from "react-i18next";
import {CommonI18N, RequestI18N, UserI18N} from "@/translations";
import ContentCopy from "@mui/icons-material/ContentCopy";
import {DialogEx} from "@/lib/components/DialogEx";
import {onClose} from "@/lib/dialog-controller";
import DateInputField from "@/lib/components/inputfields/date-input-field";
import {ApiTokenDTO} from "@/api/data-contracts";

export interface UserTokenDialogProps {
    open: boolean;
    close: () => void;
    token: ApiTokenDTO;
    handleToken: (apiTokenExpirationDate: string | undefined) => void;
}

export const UserTokenDialog = ({ open, close, token, handleToken }: UserTokenDialogProps) => {
    const { t } = useTranslation();

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
    };

    return (
        <DialogEx
            open={open}
            onClose={close}
            fullWidth
            title={t(UserI18N.form.dialog.newApiTokenTitle)}
            buttons={
                <ButtonEx
                        label={t(CommonI18N.action.close)}
                    onClick={onClose(close, () => handleToken(token?.expirationDate))}
                    color="primary"
                />
            }
        >
            <Grid container spacing={2} padding={2} width="100%">
                <Grid size={{ xs: 12 }}>
                    <DateInputField
                        name="apiTokenExpirationDate"
                        disabled
                        value={token?.expirationDate}
                        label={t(UserI18N.form.field.apiTokenExpirationDate)}
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <StringInputField
                        name="apiToken"
                        label={t(UserI18N.form.field.apiToken)}
                        value={token?.apiToken}
                        disabled
                        endAdornment={
                            <IconButtonEx
                                Icon={ContentCopy}
                                tooltip={t(RequestI18N.details.action.copy)}
                                onClick={() => copyToClipboard(token?.apiToken || "")}
                            />
                        }
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <StringInputField
                        name="companyId"
                        label={t(UserI18N.form.field.companyId)}
                        value={token?.companyId}
                        disabled
                        endAdornment={
                            <IconButtonEx
                                Icon={ContentCopy}
                                tooltip={t(RequestI18N.details.action.copy)}
                                onClick={() => copyToClipboard(token?.companyId || "")}
                            />
                        }
                    />
                </Grid>
            </Grid>
        </DialogEx>
    );
};
